export const brands = {
  rockBoard: {
    label: "Rock Board",
    href: "/rock-board",
    submenu: [
      {
        label: "Underground",
        href: "/rock-board/products?group=underground",
        submenu: [
          {
            label: "Custom",
            href: "/rock-board/products?group=underground&type=custom",
          },
          {
            label: "Modular",
            href: "/rock-board/products?group=underground&type=modular",
          },
        ],
      },
      {
        label: "Ancillary",
        href: "/rock-board/products?group=ancillary",
        submenu: [
          {
            label: "Custom",
            href: "/rock-board/products?group=ancillary&type=custom",
          },
          {
            label: "Modular",
            href: "/rock-board/products?group=ancillary&type=modular",
          },
        ],
      },
      {
        label: "Drills",
        href: "/rock-board/products?group=drills",
        submenu: [
          {
            label: "Custom",
            href: "/rock-board/products?group=drills&type=custom",
          },
          {
            label: "Modular",
            href: "/rock-board/products?group=drills&type=modular",
          },
        ],
      },
      {
        label: "Haul Trucks",
        href: "/rock-board/products?group=haul-truck",
        submenu: [
          {
            label: "Custom",
            href: "/rock-board/products?group=haul-truck&type=custom",
          },
          {
            label: "Modular",
            href: "/rock-board/products?group=haul-truck&type=modular",
          },
        ],
      },
      {
        label: "Support Vehicles",
        href: "/rock-board/products?group=support-vehicles",
        submenu: [
          {
            label: "Custom",
            href: "/rock-board/products?group=support-vehicles&type=custom",
          },
          {
            label: "Modular",
            href: "/rock-board/products?group=support-vehicles&type=modular",
          },
        ],
      },
      {
        label: "Light Vehicles",
        href: "/rock-board/products?group=light-vehicles",
      },
      {
        label: "Accessories",
        href: "/rock-board/products?group=accessories",
      },
      {
        label: "Beacons & LED Lighting",
        href: "/rock-board/products?group=beacons-led-lighting",
      },
    ],
  },
  xcelr8: {
    label: "XCELR8",
    href: "/xcelr8",
    submenu: [
      {
        label: "Hi-Vis Asset Decals",
        href: "/xcelr8/products?group=hi-vis",
      },
      {
        label: "LV Safety Stickers",
        href: "/xcelr8/products?group=lv-safety-stickers",
      },
      {
        label: "Reflective Tape",
        href: "/xcelr8/products?group=tape",
      },
      {
        label: "Reflective Tape LV Kits",
        href: "/xcelr8/products?group=lv-kits",
      },
      {
        label: "Traffolyte",
        href: "/xcelr8/products?group=traffolyte",
      },
      {
        label: "Reflective Triangles",
        href: "/xcelr8/products?group=reflective-triangles",
      },
      {
        label: "Surface Preparation",
        href: "/xcelr8/products?group=surface-preparation",
      },
    ],
  },
};
